import {} from '@routable/fund-routes';
import _intersectionWith from 'lodash/intersectionWith';
import { anyValues } from 'helpers/utility';
import {} from 'interfaces/global';
export const shouldDisplayErrorHint = (errors, fields) => {
    const hasFieldErrors = !!_intersectionWith(Object.keys(errors ?? {}), fields, (errorKey, fieldDescription) => errorKey === fieldDescription?.field).length;
    if (hasFieldErrors) {
        return false;
    }
    return anyValues(errors);
};
